module.exports = __webpack_public_path__ + "static/media/icon-clock.ea3f87d1.svg";